export const DEFAULTS = {
  PRODUCT_FORM_SELECTOR: '[data-product-form]',
  PRODUCT_OPTION_FIELD_SELECTOR: '[data-option-select]',
  PRODUCT_MAIN_IMAGE_SELECTOR: '[data-main-product-image]',
  PRODUCT_VARIANT_ID_FORM_FIELD: '[data-product-form] [name="id"]',
  PRODUCT_IMAGE_THUMBS_SELECTOR: '[data-product-thumbnail-index]',
  PRODUCT_IMAGE_THUMBS_ATTR: 'data-product-thumbnail-index',
  PRODUCT_THUMBNAIL_ACTIVE_CLASS: 'active',
  PRODUCT_STOCK_WRAPPER_ATTR: 'data-product-in-stock',
  PRODUCT_OOS_TEXT_ATTR: 'data-oos-text',
  PRODUCT_PRE_ORDER_ATTR: 'data-preOrder-text',
  PRODUCT_IN_STOCK_TEXT_ATTR: 'data-in-stock-text',
  PRODUCT_UNAVAILABLE_TEXT_ATTR: 'data-unavailable-text',
  PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR: '[data-product-form-submit]',
  PRODUCT_PRICE_SELECTOR: '[data-product-price]',
  PRODUCT_COMPARE_AT_PRICE_SELECTOR: '[data-product-compare-at-price]',
  PRODUCT_STOCK_MAP: 'data-product-stock-map',
  SWITCH_OPTIONS_ON_THUMBNAIL_SELECTION: true,
  IMAGE_SIZE: '2000x2000',
  PRODUCT_IN_STOCK_LABEL: '[data-in-stock-label]',
  PRODUCT_STOCK_LEFT_LABEL: '[data-stock-left-label]',
  PRODUCT_OOS_LABEL: '[data-oos-stock-label]',
  PRODUCT_UNAVAILABLE_LABEL: '[data-unavailable-stock-label]',
  VARIANT_SKU: '[data-variant-sku]',
  PRODUCT_OPTION_NAME: '[data-option-name]',
  PRODUCT_EST_RESTOCK_DATE: '[data-restock-id]'
}
